import { connect } from 'react-redux'

import { selectPrefersClassicView } from 'ducks/currentUser/selectors'
import { selectCurrentTicketId } from 'selectors/tickets'
import {
  selectIsCreatingNewEmail,
  selectIsLoggingNewConversation,
} from 'selectors/page'

import View from './view'

const select = state => {
  return {
    ticketId: selectCurrentTicketId(state),
    prefersClassicView: selectPrefersClassicView(state),
    isNewEmail: selectIsCreatingNewEmail(state),
    isNewConversation: selectIsLoggingNewConversation(state),
  }
}

export default connect(select)(View)
